export const Trophy = ({ color = "#FFD700", bgColor = "#534D26" }) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.361328" width="48" height="48" rx="5" fill={bgColor} />
      <g clipPath="url(#clip0_1958_386)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.75 18.3613H31.5V17.6113C31.5 16.7829 30.8284 16.1113 30 16.1113H18C17.1716 16.1113 16.5 16.7829 16.5 17.6113V18.3613H14.25C13.4216 18.3613 12.75 19.0329 12.75 19.8613V21.3613C12.75 23.4324 14.4289 25.1113 16.5 25.1113H16.8422C17.7452 27.973 20.2645 30.0227 23.25 30.3248V32.6113H21C20.5858 32.6113 20.25 32.9471 20.25 33.3613C20.25 33.7755 20.5858 34.1113 21 34.1113H27C27.4142 34.1113 27.75 33.7755 27.75 33.3613C27.75 32.9471 27.4142 32.6113 27 32.6113H24.75V30.322C27.7444 30.0191 30.2288 27.9182 31.1325 25.1113H31.5C33.5711 25.1113 35.25 23.4324 35.25 21.3613V19.8613C35.25 19.0329 34.5784 18.3613 33.75 18.3613ZM16.5 23.6113C15.2574 23.6113 14.25 22.604 14.25 21.3613V19.8613H16.5V22.8613C16.5 23.1113 16.5122 23.3613 16.5366 23.6113H16.5ZM30 22.777C30 26.107 27.3291 28.837 24.0459 28.8613H24C20.6863 28.8613 18 26.175 18 22.8613V17.6113H30V22.777ZM33.75 21.3613C33.75 22.604 32.7426 23.6113 31.5 23.6113H31.4531C31.4839 23.3343 31.4995 23.0557 31.5 22.777V19.8613H33.75V21.3613Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1958_386">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12.3613)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Coins = ({ color = "#FFD700", bgColor = "#534D26" }) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.361328" width="48" height="48" rx="5" fill={bgColor} />
      <path
        d="M27 16.3613C29.1217 16.3613 31.1566 17.2042 32.6569 18.7045C34.1571 20.2048 35 22.2396 35 24.3613C35 26.4831 34.1571 28.5179 32.6569 30.0182C31.1566 31.5185 29.1217 32.3613 27 32.3613C24.8783 32.3613 22.8434 31.5185 21.3431 30.0182C19.8429 28.5179 19 26.4831 19 24.3613C19 22.2396 19.8429 20.2048 21.3431 18.7045C22.8434 17.2042 24.8783 16.3613 27 16.3613ZM27 30.3613C28.5913 30.3613 30.1174 29.7292 31.2426 28.604C32.3679 27.4788 33 25.9526 33 24.3613C33 22.77 32.3679 21.2439 31.2426 20.1187C30.1174 18.9935 28.5913 18.3613 27 18.3613C25.4087 18.3613 23.8826 18.9935 22.7574 20.1187C21.6321 21.2439 21 22.77 21 24.3613C21 25.9526 21.6321 27.4788 22.7574 28.604C23.8826 29.7292 25.4087 30.3613 27 30.3613ZM15 24.3613C15 25.6013 15.3847 26.8107 16.1012 27.8227C16.8176 28.8347 17.8305 29.5994 19 30.0113V32.1013C15.55 31.2113 13 28.0913 13 24.3613C13 20.6313 15.55 17.5113 19 16.6213V18.7113C16.67 19.5313 15 21.7513 15 24.3613Z"
        fill={color}
      />
    </svg>
  );
};

export const Purse = ({ color = "#FFD700", bgColor = "#534D26" }) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.361328" width="48" height="48" rx="5" fill={bgColor} />
      <path
        d="M34 19.028V14.3613C34 13.8309 33.7893 13.3222 33.4142 12.9471C33.0391 12.572 32.5304 12.3613 32 12.3613H14C13.4696 12.3613 12.9609 12.572 12.5858 12.9471C12.2107 13.3222 12 13.8309 12 14.3613V34.3613C12 34.8918 12.2107 35.4005 12.5858 35.7755C12.9609 36.1506 13.4696 36.3613 14 36.3613H32C32.5304 36.3613 33.0391 36.1506 33.4142 35.7755C33.7893 35.4005 34 34.8918 34 34.3613V29.6947"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M33.9993 19.0278H24.666C23.5614 19.0278 22.666 19.9233 22.666 21.0278V27.6945C22.666 28.7991 23.5614 29.6945 24.666 29.6945H33.9993C35.1039 29.6945 35.9993 28.7991 35.9993 27.6945V21.0278C35.9993 19.9233 35.1039 19.0278 33.9993 19.0278Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M26.6673 24.3615C26.6673 23.6251 27.2643 23.0282 28.0007 23.0282C28.737 23.0282 29.334 23.6251 29.334 24.3615C29.334 25.0979 28.737 25.6948 28.0007 25.6948C27.2643 25.6948 26.6673 25.0979 26.6673 24.3615Z"
        fill={color}
      />
    </svg>
  );
};
